import React from "react";
import { Link } from "react-router-dom";
import PublicV2Layout from "../layout/PublicV2Layout";
import SocialIcons from "../../components/SocialIcons/SocialIcons";
import Tracking from "../../components/TrackingComp";
import { v2Href } from "../publicRoutes";
import "./contactV2.css";

import ScheduleRoundedIcon from "@mui/icons-material/ScheduleRounded";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";

// Mirror prod Contact.jsx values exactly.
const SEO_CONTACT = {
  title: "Contact Us | Biggin's Door Refinishing",
  description:
    "Open Monday through Friday, 9am to 5pm. Reach us by phone, text, or email — we respond quickly.",
};

const ContactV2 = (navProps) => {
  const { preview = false } = navProps;
  return (
    <PublicV2Layout seo={SEO_CONTACT} {...navProps}>
      <Tracking page={"contact"} data-nosnippet />
      <section className="bdrv2-section bdrv2-contact-sec">
        <div className="bdrv2-container bdrv2-contact-grid">
          <div className="bdrv2-contact-intro">
            <p className="bdrv2-eyebrow bdrv2-accent-text">Get in touch</p>
            <h1 className="bdrv2-contact-h1">Contact Us</h1>
            <p className="bdrv2-contact-lead">
              Questions about your door? We respond quickly during business
              hours. Reach out by phone, text, or email — or request a free
              quote.
            </p>
            <div className="bdrv2-contact-social">
              <SocialIcons />
            </div>
            <Link to={v2Href(preview, "quote")} className="bdrv2-btn bdrv2-btn--primary">
              Request a Free Quote
            </Link>
          </div>

          <div className="bdrv2-contact-card bdrv2-glass">
            <div className="bdrv2-contact-row">
              <span className="bdrv2-contact-ico bdrv2-accent-text">
                <ScheduleRoundedIcon />
              </span>
              <div>
                <span className="bdrv2-contact-label">Business Hours</span>
                <span className="bdrv2-contact-value">Mon–Fri, 9am – 5pm</span>
              </div>
            </div>
            <div className="bdrv2-contact-row">
              <span className="bdrv2-contact-ico bdrv2-accent-text">
                <PhoneRoundedIcon />
              </span>
              <div>
                <span className="bdrv2-contact-label">Phone or Text</span>
                <a className="bdrv2-contact-value bdrv2-accent-text" href="tel:12105897431">
                  210-589-7431
                </a>
              </div>
            </div>
            <div className="bdrv2-contact-row">
              <span className="bdrv2-contact-ico bdrv2-accent-text">
                <EmailRoundedIcon />
              </span>
              <div>
                <span className="bdrv2-contact-label">Email anytime</span>
                <a
                  className="bdrv2-contact-value bdrv2-accent-text"
                  href="mailto:leanne@bigginsdoorrefinishing.com"
                >
                  leanne@bigginsdoorrefinishing.com
                </a>
              </div>
            </div>
            <p className="bdrv2-contact-thanks">
              We look forward to hearing from you!
            </p>
          </div>
        </div>
      </section>
    </PublicV2Layout>
  );
};

export default ContactV2;
